// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Organization$ReactHooksTemplate = require("./settings/organization.res.js");

var initValue_0 = Organization$ReactHooksTemplate.empty();

function initValue_1(param) {
  
}

var initValue = [
  initValue_0,
  initValue_1
];

var authContext = React.createContext(initValue);

var make = authContext.Provider;

var Provider = {
  make: make
};

exports.initValue = initValue;
exports.authContext = authContext;
exports.Provider = Provider;
/* initValue Not a pure module */
